import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class ActivityTemplate extends Model {
    static entity = 'activity_templates';

    constructor(record) {
        super(record);

        this.type = 'activity_template';
    }

    static fields() {
        return {
            id: this.attr(null),
            prerequisite_id: this.attr(null),
            uuid: this.attr(null),
            activity_settings_template_id: this.attr(null),
            activity_type_id: this.attr(null),
            activity_type: this.attr(null),
            contentable_id: this.attr(null),
            contentable_type: this.attr(null),
            contentable_type_entity: this.attr(null),
            course_template_id: this.attr(null),
            section_template_id: this.attr(null),
            grading_scheme_template_id: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            is_active: this.attr(null),
            order: this.attr(null),

            is_generating: this.attr(null),
            generation_status: this.attr(null),
            generation_error: this.attr(null),

            ...super.fields(),

            course_template: this.belongsTo('course_templates', 'course_template_id'),
            section_template: this.belongsTo('section_templates', 'section_template_id'),
        };
    }

    menuItem(parentId, index) {
        return {
            id: this.id,
            parent_id: parentId,
            course_template_id: this.course_template_id,
            prerequisite: this.prerequisite,
            prerequisite_id: this.prerequisite_id,
            title: this.title,
            type: 'activity_template',
            uuid: this.uuid,
            order: index,
            completed: false,
            course_authorized_role_id: null,
            activity_type: this.activity_type,
            points_possible: this.points_possible,
            parent: this.parent,
        };
    }

    static reorder({ activity_templates, course_id }) {
        const queryBuilder = new QueryBuilder('reorder-remediation-activities');

        this.api().post(queryBuilder.toUrl(), {
            activity_templates,
            course_id,
        });
    }
}
